import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../layout/Layout.js';
import { PrivateAxios } from '../../../request/axios.js';
import { toast } from 'react-toastify';
import Modal from 'react-modal';
import { jwtDecode } from "jwt-decode";
import 'animate.css';
import ModalContrat from '../ModalContrat.js';
import ConsultationAll from './ConsultationAll';
import ConsultationUG from './ConsultationUG';
import ConsultationInt from './ConsultationInt';


const ConsulterContrat = () => {
    const [contrats, setContrats] = useState({});
    const [selectedContrat, setSelectedContrat] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userRoles, setUserRoles] = useState([]);
    const { zone } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        let uri = '/contrat';
        if (zone === 'ug') uri = '/contrat/ug';
        else if (zone === 'int') uri = '/contrat/int';
        else if (zone === 'all') uri = '/contrat/all';
        else {
            toast.error("Paramètre d'URL invalide. Redirection...");
            navigate('/404');
            return;
        }

        const fetchContrats = async () => {
            try {
                const response = await PrivateAxios.get(uri);
                setContrats(response.data);
            } catch (err) {
                toast.error("Erreur lors de la récupération des contrats.");
            }
        };

        const closeModalUseEffect = () => {
            setSelectedContrat(null);
            setIsModalOpen(false);
        };
        closeModalUseEffect();
        fetchContrats();
    }, [zone, navigate]);

    useEffect(() => {
        const token = localStorage.getItem('assistance-axa-token');
        if (token) {
            const decoded = jwtDecode(token);
            const currentTime = Date.now() / 1000;
            if (decoded.exp < currentTime) {
                navigate('/logout', { state: { message: 'Votre session a expiré. Veuillez vous reconnecter.' } });
            }
            setUserRoles(decoded.roles || []);
        }
    }, [navigate]);

    const openModal = (contrat) => {
        setSelectedContrat(contrat);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setSelectedContrat(null);
        setIsModalOpen(false);
    };


    const renderContent = () => {
        if (zone === 'all') {
            return <ConsultationAll contrats={contrats.contrats_par_ug || {}} openModal={openModal} />;
        } else if (zone === 'ug') {
            return <ConsultationUG contrats={contrats.contrats_par_intermediaire || {}} openModal={openModal} />;
        } else if (zone === 'int') {
            return <ConsultationInt contrats={contrats.contrats || []} openModal={openModal} />;
        }
    };


    return (
        <Layout>
            <div className="p-6 bg-gray-100 rounded-lg shadow-md">
                <h1 className="mb-6 text-2xl font-bold text-black">Consultation des Contrats</h1>
                {renderContent()}
            </div>
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Détails du Contrat"
                className="fixed inset-0 max-w-3xl p-8 mx-auto mt-20 overflow-auto bg-white border rounded-lg shadow-lg lg:w-3/4 sm:w-full"
                overlayClassName="fixed inset-0 bg-black bg-opacity-50"
            >
                <ModalContrat
                    selectedContrat={selectedContrat}
                    zone={zone}
                    userRoles={userRoles}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    navigate={navigate}
                    closeModal={closeModal}
                />
            </Modal>

        </Layout>
    );
};

Modal.setAppElement('#root');

export default ConsulterContrat;
